import { GameVars } from "./../../GameVars";
import { GameConstants } from "./../../GameConstants";

export class GameTitleContainer extends Phaser.GameObjects.Container {

    private chars: Phaser.GameObjects.Image [];
    private f: number;
    private i: number;

    constructor(scene: Phaser.Scene) {

        super(scene);

        this.x = GameConstants.GAME_WIDTH / 2;
        this.y = 205;

        this.scaleX = GameVars.scaleX;

        this.f = 0;
        this.i = 0;

        const triangle = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "splash_illust_08.png");
        this.add(triangle);

        this.chars = [];

        // einstein
        let char = new Phaser.GameObjects.Image(this.scene, 70, 35, "texture_atlas_1", "splash_illust_07.png");
        char.setOrigin(.5, 1);
        this.add(char);
        this.chars.push(char);

        // mono
        char = new Phaser.GameObjects.Image(this.scene, -60, 80, "texture_atlas_1", "splash_illust_06.png");
        char.setOrigin(.5, 1);
        this.add(char);
        this.chars.push(char);

        // maoi
        char = new Phaser.GameObjects.Image(this.scene, 0, 50, "texture_atlas_1", "splash_illust_05.png");
        char.setOrigin(.5, 1);
        this.add(char);
        this.chars.push(char);

        // hamburguesa
        char = new Phaser.GameObjects.Image(this.scene, -130, 140, "texture_atlas_1", "splash_illust_04.png");
        char.setOrigin(.5, 1);
        this.add(char);
        this.chars.push(char);

        // monsieur
        char = new Phaser.GameObjects.Image(this.scene, -50, 170, "texture_atlas_1", "splash_illust_02.png");
        char.setOrigin(.5, 1);
        this.add(char);
        this.chars.push(char);

        // rasta
        char = new Phaser.GameObjects.Image(this.scene, 110, 166, "texture_atlas_1", "splash_illust_03.png");
        char.setOrigin(.5, 1);
        this.add(char);
        this.chars.push(char);
        
        // chica
        char = new Phaser.GameObjects.Image(this.scene, 10, 160, "texture_atlas_1", "splash_illust_01.png");
        char.setOrigin(.5, 1);
        this.add(char);
        this.chars.push(char);

        const banana = new Phaser.GameObjects.Image(this.scene, 0, 220, "texture_atlas_1", "title_banana.png");
        banana.alpha = 0;
        this.add(banana); 

        const poker = new Phaser.GameObjects.Image(this.scene, 0, 285, "texture_atlas_1", "title_poker.png");
        poker.alpha = 0;
        this.add(poker); 

        this.scene.tweens.add({
            targets: banana,
            alpha: 1,
            y: 200,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 450,
            delay: 800
        });

        this.scene.tweens.add({
            targets: poker,
            alpha: 1,
            y: 265,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 450,
            delay: 1300
        });

        this.scene.sys.updateList.add(this);
    }

    public preUpdate(time: number, delta: number): void {

        this.f ++;

        if (this.f === 20) {

            this.f = 0;

            const rnd = Math.random();

            if (rnd > .65) {
                // angulo
                this.scene.tweens.add({
                    targets: this.chars[this.i],
                    angle: Math.random() > .5 ? -3 : 3,
                    ease: Phaser.Math.Easing.Cubic.Out,
                    duration: 240,
                    yoyo: true
                });
            } else if (rnd > .35) {
                // pulso escala
                this.scene.tweens.add({
                    targets:  this.chars[this.i],
                    scaleX: 1.05,
                    scaleY: .95,
                    duration: 240,
                    yoyo: true
                });
            } else {
                // saltito
                this.scene.tweens.add({
                    targets: this.chars[this.i],
                    y: this.chars[this.i].y - 10,
                    duration: 100,
                    yoyo: true
                });
            }

            if (this.i < this.chars.length - 1) {
                this.i ++;
            } else {
                this.i = 0;
                this.chars = Phaser.Utils.Array.Shuffle(this.chars);
            }
        }
    }
}
